import size from 'size';
import Canvas from 'canvas';
import FPSControl from 'fps-control';
import anime from 'animejs';
export default class Noise {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.canvas = new Canvas({
      ratio: getDpr(),
      parent: options.parent
    });
    this.noises = [];
    this.current = 0;
    this.options = Object.assign({
      opacity: 0.2
    }, options);
    Object.assign(this.canvas.el.style, {
      position: 'fixed',
      left: 0,
      top: 0,
      opacity: 0,
      pointerEvents: 'none'
    });
    this.fps = new FPSControl(8);
    size.addListener(this.onResize.bind(this));
    this.onResize(size.width, size.height);
    this.update = this.update.bind(this);
  }

  onResize(width, height) {
    this.canvas.resize(width, height);
    if (!this.options.texture) this.generate();
  }

  generate() {
    for (let i = 0; i < 6; i++) {
      let canvas = new Canvas({
        ratio: getDpr()
      });
      canvas.resize(size.width, size.height);
      var imageData = canvas.context.getImageData(0, 0, canvas.width, canvas.height);

      for (let j = 0; j < imageData.data.length; j += 4) {
        let random = ~~(Math.random() * 255);
        imageData.data[j] = random;
        imageData.data[j + 1] = random;
        imageData.data[j + 2] = random; // imageData.data[j + 3] = 255 * this.options.opacity;

        imageData.data[j + 3] = 255;
      }

      canvas.context.putImageData(imageData, 0, 0);
      this.noises[i] = canvas;
    }
  }

  start() {
    if (!window.requestAnimationFrame) return;
    requestAnimationFrame(this.update);
    anime({
      targets: this.canvas.el,
      opacity: [0, this.options.opacity],
      duration: 600,
      easing: 'linear'
    });
  }

  update(time) {
    requestAnimationFrame(this.update);
    if (!this.fps.check()) return;
    this.canvas.clear();

    if (this.options.texture) {
      let context = this.canvas.context;
      let img = this.options.texture;
      let width = img.naturalWidth;
      let height = img.naturalHeight;
      var w = Math.ceil(size.width / width);
      var h = Math.ceil(size.height / height);
      let cw = this.canvas.width;
      let ch = this.canvas.height; // context.globalAlpha = this.options.opacity

      let index = (this.current + 1) % 4;
      this.current = index; // for(var i = 0; i < w; i++) {
      // for(var j = 0; j < h; j++) {

      let i = 0;
      let j = 0;
      context.setTransform(1, 0, 0, 1, 0, 0);
      context.translate(cw * 0.5, ch * 0.5);
      context.rotate(Math.PI * 0.5 * index);
      context.translate(-cw * 0.5, -ch * 0.5);
      context.drawImage(img, i * width, j * height, width, height); // }
      // }
      // context.globalAlpha = 1
    } else {
      let index = (this.current + 1) % (this.noises.length - 1);
      this.current = index;
      this.canvas.context.drawImage(this.noises[index].el, 0, 0);
    } // white spots
    // let dpr = this.canvas.ratio
    // let count = Math.round(3 + Math.random() * 4)
    // this.canvas.context.fillStyle = 'white'
    // for (let i = 0; i < count; i++) {
    //     let x = Math.round(size.width * dpr * Math.random())
    //     let y = Math.round(size.width * dpr * Math.random())
    //     this.canvas.context.fillRect(x, y, 1, 1)
    // }

  }

}

function getDpr() {
  let dpr = window.devicePixelRatio || 1;
  if (dpr > 2) return 1.35;
  if (dpr > 1) return 0.8;
  return 0.5;
}